import { inject, Injectable } from '@angular/core';
import { firstValueFrom, take } from 'rxjs';
import Survicate from '@survicate/survicate-web-package/survicate_widget'
import { ProfileService } from '../../modules/profile/providers/profile.service';
import { getProfileType, Profile } from '../../modules/profile/store/profile.entity';
import { Institution } from '../../entities/institution/institution.model';
import { institutionToSurveyEventName, PATIENTUS_FEEDBACK_SURVEY, WORKSPACE_KEY } from './survicate.config';

@Injectable({
    providedIn: 'root'
})
export class SurvicateService {
    private readonly profileService = inject(ProfileService);
    private isInitialized = false;
    private profile: Profile;

    async init(): Promise<void> {
        this.profile = await firstValueFrom(
            this.profileService.getCurrentProfileDataObserver().pipe(take(1))
        );

        const traits = {
                user_id: this.profile?.id,
                profile_type: this.profile?.type ? getProfileType(this.profile.type) : 'anonymous',
                institution: this.profile?.institution
            };

        await Survicate.init({
            workspaceKey: WORKSPACE_KEY,
            disableSensitiveDataPersistence: true,
            traits: this.profile ? traits : {}
        });

        this.isInitialized = true;
    }

    async showSurvey(eventName?: string): Promise<void> {
        if (!this.isInitialized) await this.init()
        const surveyEventName = eventName ?? this.getSurveyEventNameByProfileType();
        Survicate.invokeEvent(surveyEventName);
    }

    async showFeedbackSurvey(): Promise<void> {
        await this.showSurvey(PATIENTUS_FEEDBACK_SURVEY);
    }

    private getSurveyEventNameByProfileType(): string {
        const institution = this.profile?.institution ?? Institution.PATIENTUS;
        const surveyEventName = institutionToSurveyEventName[institution] ?? institutionToSurveyEventName[Institution.PATIENTUS];
        return surveyEventName[getProfileType(this.profile.type)];
    }
}
